if (!customElements.get('delivery-date')) {
  customElements.define('delivery-date', class extends HTMLElement {

    static API_BASE_URL          = "https://factorychic-configurateur-prod.fly.dev"
    static API_ENDPOINT_DELIVERY = '/api/delivery/estimate'

    _timer    = null
    _elements = { delay: null, countdown: null }

    connectedCallback() {
      const productId = this.dataset.productIdLegacy
      if ( ! productId ) return

      this._elements.delay      = this.querySelector(':scope [data-delay]')
      this._elements.countdown  = this.querySelector(':scope [data-cutoff-countdown]')
      this._elements.delay_next = this.querySelector(':scope [data-delay-late]')

      this._fetch(productId)
        .then(this._render.bind(this))
        .catch(console.error)
    }

    disconnectedCallback() {
      if ( ! this._timer ) return

      clearInterval(this._timer)
      this._timer = null
    }

    _fetch(id) {
      const url = `${this.constructor.API_BASE_URL}${this.constructor.API_ENDPOINT_DELIVERY}/${id}`

      return fetch(url)
        .then(resp => {
          if ( ! resp.ok ) throw new Error('HTTP ' + resp.status)
          else             return resp.json()
        })
        .then(data => {
          if ( ! data.success ) throw new Error('API error')
          else                  return data
        })
    }

    _render(data) {
      const { delay, countdown, delay_next } = this._elements
      const { ms_per_min }       = this._getTimeUnits()

      if ( ! this.isConnected ) return

      if( delay && data.delivery_date_long )           this._setDate(delay, data.delivery_date_long)
      if( delay_next && data.delivery_date_late_long ) this._setDate(delay_next, data.delivery_date_late_long)
      if( countdown && data.cutoff_deadline )          this._setCountdown(countdown, data.cutoff_deadline)

      this._ticker(() => this._setCountdown(countdown, data.cutoff_deadline), ms_per_min)
    }

    _setDate(target, value) {
      const { date } = this._getFormatDate(value)

      target.textContent = `le ${date}`
    }

    _setCountdown(target, value) {
      const { days, hours, mins } = this._getFormatCountdown(value)

      if (days > 0)       target.textContent = `dans les ${days}j et ${hours}h`
      else if (hours > 0) target.textContent = `dans les ${hours}h`
      else                target.textContent = `dans les ${mins}min`
    }

    _getFormatDate(value) {
      return {
        date: value
      }
    }

    _getFormatCountdown(value) {
      const { ms_per_min, min_per_hour, min_per_day } = this._getTimeUnits()

      const deadline = new Date(value)
      const diffMs   = Math.max(0, deadline - new Date())
      const totalMin = Math.floor(diffMs / ms_per_min)

      return {
        days:  Math.floor(totalMin / min_per_day),
        hours: Math.floor((totalMin % min_per_day) / min_per_hour),
        mins:  totalMin % min_per_hour
      }
    }

    _getTimeUnits() {
      const ms_per_sec   = 1000
      const sec_per_min  = 60
      const min_per_hour = 60
      const hour_per_day = 24

      return {
        ms_per_sec,
        sec_per_min,
        min_per_hour,
        hour_per_day,
        ms_per_min:  ms_per_sec * sec_per_min,
        min_per_day: min_per_hour * hour_per_day
      }
    }

    _ticker(callback, interval) {
      callback()

      this._timer = setInterval(callback, interval)
    }
  });
}